import React, { Component, Fragment } from "react";
import {Modal} from "../AdministrationLogoutPopup"
import {  withRouter } from "react-router-dom";
class AdministrationMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  logoutHandler = () => {
    // alert(JSON.stringify( this.props.cookies.get("njt_admin_userId")));
    var data = {
      UserId: this.props.cookies.get("njt_admin_userId").application_user_id
    };
    // alert(data.njt_admin_userId)
    this.props.AdministrationLogout(
      {...data, history:this.props.history},
      this.props.cookies
    );
    this.closeModel()
    // this.props.history.push({
    //   pathname: "/login_page"
    // });
  };
  closeModel = ()=>{
    this.setState({
      open: false
    })
  }
  openModel = () =>{
    this.setState({
      open: true
    })
  }
  render() {
    return (
      <Fragment>
       {this.state.open? <Modal onClose = {this.closeModel} onConfirm={this.logoutHandler}/>:null}
        <button id="signOutBtn" className={this.props.className} onClick={this.openModel}>
          Sign Out
        </button>
      </Fragment>
    );
  }
}

export default withRouter(AdministrationMain);
